export const ADMIN_RESEND_BLOCKED_EMAIL_TYPES = [
  "genie_widget_question",
  "connection_test",
  "print_order",
  "team_invitation",
  "genie_access_approved",
  "genie_access_invited",
  "activation_pack_customers_activated",
  "activation_pack_app_link",
  "activation_pack_presentation",
] as const;

export interface EmailLogResendCandidate {
  status?: unknown;
  email_type?: unknown;
  provider_response?: unknown;
}

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null && !Array.isArray(value);

export const canResendEmailLog = (
  candidate: EmailLogResendCandidate,
): boolean =>
  candidate.status === "failed" &&
  typeof candidate.email_type === "string" &&
  !(ADMIN_RESEND_BLOCKED_EMAIL_TYPES as readonly string[]).includes(
    candidate.email_type,
  ) &&
  isRecord(candidate.provider_response) &&
  candidate.provider_response.deliveryState === "not_sent";
